module.exports = __webpack_public_path__ + "img/icon-payment-methods.b0a638c9.svg";